import { useRef, useState, useCallback } from 'react';
import { Formik, Form, Field } from 'formik';

import { Modal, FormInput, Label, Button } from '@component';
import { useServices } from '@services';
import PulseLoader from 'react-spinners/PulseLoader';
import { CountrySelect, StateSelect } from 'react-country-state-city';
import "react-country-state-city/dist/react-country-state-city.css";

export const NewUserForm = ({ item, close, saved }) => {
  const { functions, db } = useServices();
  const [error, setError] = useState('');

  const validate = values => {
    const errors = {};
    if (!values.displayName) {
      errors.displayName = 'Required';
    }
    if (!values.email) {
      errors.email = 'Required';
    }
    if (!values.uid && !values.password) {
      errors.password = 'Required';
    }

    return errors;
  };

  const createUser = useCallback(
    newUser => {
      const { firstName, lastName, ...authUser } = newUser;
      const createUserFunction = functions.httpsCallable('api/users/create');
      createUserFunction(authUser)
        .then(() => {
          close();
          saved();
        })
        .catch(err => setError(err.message)).finally(() => {
          updateUserCollection(db, newUser);
        });
    },
    [functions, db, close, saved]
  );

  const saveUser = useCallback(
    newUser => {
      const { firstName, lastName,  ...authUser } = newUser;
      if (!authUser.password) delete authUser.password;
      const updateUserFunction = functions.httpsCallable('api/users/update');
      updateUserFunction(authUser)
        .then(() => {
          close();
          saved();
        })
        .catch(err => setError(err.message)).finally(() => {
        updateUserCollection(db, newUser);
      });
    },
    [functions, db, close, saved]
  );

  function updateUserCollection(db, updatedUser){
      // const data = { firstName: updatedUser.firstName };
    db.collection('users').doc(updatedUser.uid).set( updatedUser , { merge: true });
    console.log(updatedUser)
  }

  const formikRef = useRef();;
  const [country, setCountry] = useState(null);
  const [currentState, setCurrentState] = useState(null);

  return (
    <Modal
      visible={!!item}
      onClose={close}
      title={item && item.uid ? 'View / Edit User' : 'Add new User'}
      className="text-black"
    >
      <Formik
        innerRef={formikRef}
        initialValues={{ role: 'viewer', firstName: '', lastName: '', ...item }}
        validate={validate}
        onSubmit={(user, { setSubmitting }) => {
          user.country = item.country;
          user.country_code = item.country_code;
          user.state = item.state;
          user.stateCode = item.stateCode;
          user?.uid ? saveUser(user) : createUser(user);
        }}
      >
        {({ values, isSubmitting }) => (
          <>
            <Form>
              <Label htmlFor="firstName">First Name</Label>
              <FormInput name="firstName"></FormInput>

              <Label htmlFor="lastName" className="mt-4">Last Name</Label>
              <FormInput name="lastName"></FormInput>

              <Label htmlFor="displayName" className="mt-4">Display Name *</Label>
              <FormInput name="displayName"></FormInput>

              <div>
              <h6>Country</h6>
              <CountrySelect
                containerClassName="form-group"
                inputClassName=""
                onChange={(_country) => {
                  setCountry(_country);
                  item.country = _country.name;
                  item.country_code = _country.iso2;
                console.log(item.country + " " + _country.name)}}
                onTextChange={(_txt) => console.log(_txt)}
                placeHolder="Select Country"
                defaultValue= {item?.country || ''}
              />
              </div>

              {(item?.country === 'Australia' ) && (
                <div>
                  <h6>State</h6>
                  <StateSelect
                    countryid={14}
                    containerClassName="form-group"
                    inputClassName=""
                    onChange={(_state) => {setCurrentState(_state); item.state = _state.name; item.stateCode = _state.state_code}}
                    onTextChange={(_txt) => console.log(_txt)}
                    defaultValue= {item?.state || ''}
                    placeHolder="Select State"
                  />
                </div>
              )}

              <Label htmlFor="password" className="mt-4">
                {item?.uid ? 'Change Password' : 'Password *'}
              </Label>
              <FormInput name="password" type="password"></FormInput>

              <Label htmlFor="email" className="mt-4">
                Email *
              </Label>
              <FormInput name="email" type="email"></FormInput>

              {/* <Label htmlFor="phoneNumber" className="mt-4">
                Phone No.
              </Label>
              <FormInput name="phoneNumber"></FormInput> */}

              {item?.uid && (
                <>
                  <Label htmlFor="role" className="mt-4">
                    Role
                  </Label>
                  <div className="flex items-center">
                    <Field type="radio" name="role" value="admin" className="mr-2"></Field>
                    <div>Admin</div>
                  </div>
                  <div className="flex items-center">
                    <Field type="radio" name="role" value="editor" className="mr-2"></Field>
                    <div>Editor</div>
                  </div>
                  <div className="flex items-center">
                    <Field type="radio" name="role" value="viewer" className="mr-2"></Field>
                    <div>Viewer</div>
                  </div>
                  <div className="flex items-center">
                    <Field type="radio" name="role" value="" className="mr-2"></Field>
                    <div>App User</div>
                  </div>
                </>
              )}

              <div className="flex justify-end">
                <Button type="submit" disabled={!!isSubmitting} className="btn btn-brand btn-elevate btn-icon-sm mt-4">
                  {isSubmitting ? <PulseLoader color="white" size={10}></PulseLoader> : 'Submit'}
                </Button>
              </div>
            </Form>
          </>
        )}
      </Formik>
      {!!error && (
        <div className="text-error-200 pt-4 text-center">
          {error === 'internal' ? 'An unexpected error occurred' : error}
        </div>
      )}
    </Modal>
  );
};
